module.exports = __webpack_public_path__ + "img/IElephantGatherer64_ua.d279bdf8.webp";